export const API_WEBHOOK_ENDPOINT = 'webhook'

export const ADYEN_LOGGER_PREFIX = '[VSF2AdyenSalesforce]'

export const MALFORMED_PRICE_QUERY_STRING = 'malformed-price'

export const PAYMENT_METHOD_NAME_KEY = 'payment-method-name'

export const ERROR_PAYMENT_QUERY_PARAMS = {
  generic_error: 'paymentError',
  payment_cancelled: 'paymentCancelled',
  gift_card_error: 'giftCardError',
}

export const PAYMENT_METHOD_IDS = {
  adyen: 'AdyenComponent',
  flexiti: 'Flexiti',
  givex: 'GIFT_CERTIFICATE',
  humm: 'HUMM',
  latitude: 'LatitudeLongTerm',
  zeroBalance: 'ZeroBalance',
}

export const ADYEN_PAYMENT_NAMES = {
  afterpaytouch: 'Afterpay',
  alipay: 'AliPay',
  affirm: 'Affirm',
  paypal: 'PayPal',
  scheme: 'Credit Card',
  clicktopay: 'Click to Pay',
  unionpay: 'UnionPay',
  wechatpay: 'WeChat Pay',
  wechatpaySDK: 'WeChat Pay',
  wechatpayWeb: 'WeChat Pay',
  applepay: 'Apple Pay',
  applepay_express: 'Apple Pay Express',
  googlepay: 'Google Pay',
  googlepay_express: 'Google Pay Express',
  zip: 'Zip',
}

export const ADYEN_PAYMENT_LABELS_MAPPING = {
  Cards: 'Credit Card',
}

export const DIRECT_PAYMENT_NAMES = {
  [PAYMENT_METHOD_IDS.flexiti]: 'Flexiti',
  [PAYMENT_METHOD_IDS.givex]: 'Gift Certificate',
  [PAYMENT_METHOD_IDS.humm]: 'Humm',
  [PAYMENT_METHOD_IDS.latitude]: {
    AU: 'Latitude Interest-Free',
    NZ: 'Gem Interest-Free',
  },
  [PAYMENT_METHOD_IDS.zeroBalance]: 'Zero Balance',
}

export const GIVEX_RESULT_CODE = {
  success: '0',
  invalid_pin: '41',
  cert_not_exist: '2',
}
